export default {
  PUSH_WS: 'push.api.driftqa.com'
};